
import Vue from "vue";

export default Vue.extend({
  props: {
    employeesCount: {
      type: Number,
    },
  },
});
